module.exports = __webpack_public_path__ + "static/img/brees-2017-img-in-copy.f974387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-img-in-copy.jpg
// module id = BlDF
// module chunks = 1